import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { getBrowserMetadata } from '@/hooks/use-user-platform';
import { DISPLAY_STORAGE_KEY } from '@/utils/constants';

export interface LayoutStore {
  isDesktop: boolean;
  sessionKey: string | null;
  setIsDesktop: (isDesktop?: boolean) => Promise<void>;
}

export const useLayoutStore = create<LayoutStore>()(
  immer(
    (set): LayoutStore => ({
      isDesktop: false,
      sessionKey: '',
      setIsDesktop: async (isDesktop) => {
        let display = isDesktop ? 'desktop' : 'mobile';

        if (typeof isDesktop !== 'boolean') {
          const stored = sessionStorage.getItem(DISPLAY_STORAGE_KEY);
          if (stored && ['desktop', 'mobile'].includes(stored)) display = stored;
          else display = (await getBrowserMetadata()).osType;
        }

        set({ isDesktop: display === 'desktop' });
        sessionStorage.setItem(DISPLAY_STORAGE_KEY, display);
      },
    }),
  ),
);

export const setSessionKey = (sessionKey: string) => useLayoutStore.setState({ sessionKey });

export const setIsDesktop = useLayoutStore.getState().setIsDesktop;
